<template>
  <div
    ref="container"
    class="iframe-container is-lazy"
    :class="{ 'is-active': inViewport }"
    :style="{ computedHeight: hasAdaptiveHeight }"
  >
    <u-intersect root-margin="0px 0px 250px 0px" :once="true" @enter="onEnter">
      <iframe
        ref="iframe"
        :src="inViewport ? src : 'data:,'"
        :title="title"
        class="iframe"
        :style="{
          height: hasAdaptiveHeight ? `${iframeHeight}px` : false,
          width: hasAdaptiveHeight ? `100%` : false,
        }"
      ></iframe>
    </u-intersect>
  </div>
</template>

<script>
import { ResizeObserver } from '@juggle/resize-observer';

export default {
  props: {
    title: {
      type: String,
    },
    src: {
      type: String,
      required: true,
    },
    adaptiveHeight: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      iframeHeight: 0,
      iframeHeightObserver: undefined,
      inViewport: false,
    };
  },
  computed: {
    isSameHost() {
      const browserUrl = window.location;
      const iframeUrl = new URL(this.src, window.location.href);
      return browserUrl.hostname === iframeUrl.hostname;
    },
    hasAdaptiveHeight() {
      return this.isSameHost && this.adaptiveHeight;
    },
  },
  mounted() {
    if (this.hasAdaptiveHeight) {
      this.$refs.iframe.addEventListener('load', this.watchHeight);
    }
  },
  beforeDestroy() {
    if (this.iframeHeightObserver) this.iframeHeightObserver.disconnect();
  },
  methods: {
    watchHeight() {
      this.iframeHeightObserver = new ResizeObserver(this.updateHeight);
      this.iframeHeightObserver.observe(
        this.$refs.iframe.contentWindow.document.body
      );
    },
    updateHeight() {
      this.iframeHeight =
        this.$refs.iframe.contentWindow.document.body.scrollHeight;
    },
    onEnter() {
      this.inViewport = true;
    },
  },
};
</script>
